var PropertiesFormHelper = function () {
  this.checkPropertyReferences = function (
    selector,
    url,
    resource,
    templateName,
  ) {
    var formValues = this.getFormValues(selector, resource),
      params = { [resource]: formValues },
      warnModal = new IO.Views.Components.ConfirmationDialog({
        url: url,
        jst_template: templateName, // eslint-disable-line camelcase
        proceedIfDataIsEmpty: true,
        type: 'POST',
        emptyCheck: function (data) {
          return $.isEmptyObject(data.resources.fields);
        },
      });

    warnModal.impact(params);
    warnModal.answer(function (shouldProceed) {
      if (shouldProceed) {
        $(selector).addClass('prop-fields-checked-yes');
        $(selector).submit();
      } else {
        $(selector).addClass('prop-fields-checked-no');
      }
      warnModal.destroy();
    });
  };

  this.getFormValues = function (selector, resource) {
    var values = $(selector).serializeArray(),
      formObject = {},
      complexType = /\[\w*]/,
      extractMetaData = /(\w+)\[(\w+)?]/,
      nameIDX = 1,
      keyIDX = 2;

    values.forEach(function (row) {
      var value = row.value,
        name,
        metaData;

      if (row.name.indexOf(resource) > -1) {
        let baseName = row.name.match('properties')
          ? `${resource}[properties]`
          : resource;

        name = row.name.replace(baseName + '[', '');
        if (name.indexOf('][]') > -1) {
          name = name.replace('][]', '[]');
        } else {
          name = name.replace(']', '');
        }

        if (name.match(complexType) !== null) {
          metaData = name.match(extractMetaData);
          name = metaData[nameIDX];
          if (metaData[keyIDX] === undefined) {
            value = formObject[name] || [];
            value.push(row.value);
          } else {
            value = formObject[name] || {};
            value[metaData[keyIDX]] = row.value;
          }
        }
        formObject[name] = value;
      }
    });

    return formObject;
  };
};

module.exports = PropertiesFormHelper;
